import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import CustomDropdown from "../common/CustomDropdown";

const RcsDashboardFilterModal = ({
  show,
  handleClose,
  setFilterData,
  filterData,
  handleReset,
  setHistoryData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  callApi,
}) => {
  const userRole = sessionStorage.getItem("userRole");
  const isCust = userRole === "CUST";
  const availableTabs = [
    "Created Date",
    ...(isCust ? ["Campaign ID"] : ["Company Name"]),
  ];

  const [selectedTab, setSelectedTab] = useState("Created Date");

  const {
    handleSubmit,
    setValue,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
      campaignId: filterData.campaignId || "",
      companyName: filterData.companyName || "",
    },
    mode: "onChange",
  });

  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");
  const [campaignList, setCampaignList] = useState([]);
  const [customerNameOpen, setCustomerNameOpen] = useState(false);
  const [customerList, setCustomerList] = useState([]);

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`; // DD-MM-YYYY
  };

  const onSubmit = async (data) => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const payload = {
      username: loggedInUserName,
      fromDate: data?.fromDate
        ? formatDate(data.fromDate)
        : formatDate(startOfMonth),
      toDate: data?.toDate ? formatDate(data.toDate) : formatDate(today),
      campaignId: data?.campaignId || "",
      companyName: data?.companyName || "",
    };

    setFilterData(data);
    // callApi(payload);

    const res = await callApi(payload);
    if (res?.status === true) {
      handleClose(); // ✅ close modal after success
    }
  };

  const fetchCampaignIdListData = async () => {
    try {
      const response = await axiosPostApi(
        `${apiList.RCS_CAMPAIGN_ID_LIST}?username=${loggedInUserName}`
      );

      if (response?.status === 200) {
        const campaigns = response?.data?.data?.["00"] || [];
        const filteredCampaigns = campaigns?.filter((c) => c.trim() !== "");
        setCampaignList(filteredCampaigns);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const toggleCustomerNameDropdown = () =>
    setCustomerNameOpen(!customerNameOpen);

  useEffect(() => {
    fetchCustomerData();
  }, []);

  const fetchCustomerData = async () => {
    try {
      const response = await axiosGetApi(apiList.ALL_ACTIVE_CUSTOMER_DATA);

      if (response?.status === 200) {
        setCustomerList(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h5 className="modal-title main-title">RCS Dashboard Filter</h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {availableTabs.map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">From Date</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="fromDate"
                                control={control}
                                rules={{
                                  validate: {
                                    validDate: (value) =>
                                      !value ||
                                      !isNaN(Date.parse(value)) ||
                                      "Invalid From Date",
                                    notFuture: (value) =>
                                      !value ||
                                      new Date(value) <= new Date() ||
                                      "From Date cannot be in the future",
                                    beforeToDate: (value) =>
                                      !value ||
                                      !filterData.toDate ||
                                      new Date(value) <=
                                        new Date(filterData.toDate) ||
                                      "From Date must be before To Date",
                                    requiredIfToDate: (value, formValues) =>
                                      !formValues.toDate ||
                                      !!value ||
                                      "From Date is required when To Date is selected",
                                  },
                                }}
                                render={({ field }) => (
                                  <>
                                    <input
                                      {...field}
                                      type="date"
                                      className="dateInput"
                                      value={filterData.fromDate || ""}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setValue("fromDate", val);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          fromDate: val,
                                        }));
                                        field.onChange(val);
                                      }}
                                      max={getTodayDate()}
                                    />
                                    {errors.fromDate && (
                                      <span className="error-text">
                                        {errors.fromDate.message}
                                      </span>
                                    )}
                                  </>
                                )}
                              />
                            </div>
                          </div>
                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">To Date</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="toDate"
                                control={control}
                                rules={{
                                  validate: {
                                    validDate: (value) =>
                                      !value ||
                                      !isNaN(Date.parse(value)) ||
                                      "Invalid To Date",
                                    notFuture: (value) =>
                                      !value ||
                                      new Date(value) <= new Date() ||
                                      "To Date cannot be in the future",
                                    afterFromDate: (value) =>
                                      !value ||
                                      !filterData.fromDate ||
                                      new Date(value) >=
                                        new Date(filterData.fromDate) ||
                                      "To Date must be after From Date",
                                    requiredIfFromDate: (value, formValues) =>
                                      !formValues.fromDate ||
                                      !!value ||
                                      "To Date is required when From Date is selected",
                                  },
                                }}
                                render={({ field }) => (
                                  <>
                                    <input
                                      {...field}
                                      type="date"
                                      className="dateInput"
                                      value={filterData.toDate || ""}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setValue("toDate", val);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          toDate: val,
                                        }));
                                        field.onChange(val);
                                      }}
                                      max={getTodayDate()}
                                    />
                                    {errors.toDate && (
                                      <span className="error-text">
                                        {errors.toDate.message}
                                      </span>
                                    )}
                                  </>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {selectedTab === "Campaign ID" && (
                        <>
                          <div className="form-group position-relative">
                            <label className="dateLabel">Campaign ID</label>
                            <select
                              className="form-control select-dropdown"
                              id="campaignId"
                              placeholder="Select Id"
                              onClick={() => {
                                toggleCustomerNameDropdown();
                                if (campaignList.length === 0)
                                  fetchCampaignIdListData(filterData.username);
                              }}
                              value={filterData.campaignId || ""}
                              onChange={(e) => {
                                const selectedCampaign = e.target.value;

                                setFilterData((prev) => ({
                                  ...prev,
                                  campaignId: selectedCampaign,
                                }));

                                setValue("campaignId", selectedCampaign);
                              }}
                            >
                              <option value="" disabled>
                                Select Campaign Id
                              </option>
                              {campaignList.map((campaign) => (
                                <option key={campaign} value={campaign}>
                                  {campaign}
                                </option>
                              ))}
                            </select>

                            <span className="position-absolute select-icon !top-[69%]">
                              {customerNameOpen ? (
                                <ChevronUp />
                              ) : (
                                <ChevronDownIcon />
                              )}
                            </span>
                          </div>
                          {errors.campaignId && (
                            <span className="error">{errors.campaignId}</span>
                          )}
                        </>
                      )}

                      {selectedTab === "Company Name" && (
                        <>
                          <div className="form-group position-relative">
                            {/* <Controller
                              name="companyId"
                              control={control}
                              render={({ field }) => (
                                <CustomDropdown
                                  customerList={customerList}
                                  setFilterData={setFilterData}
                                  filterData={filterData}
                                  setValue={setValue}
                                  field={field}
                                />
                              )}
                            /> */}
                            <Controller
                              name="companyId"
                              control={control}
                              render={({ field }) => (
                                <CustomDropdown
                                  options={customerList}
                                  valueKey="customerCode"
                                  labelKey="name"
                                  value={field.value}
                                  placeholder="Select Company"
                                  onChange={(item) => {
                                    field.onChange(item.customerCode);                         

                                    setFilterData((prev) => ({
                                      ...prev,
                                      companyId: item.customerCode,
                                      companyName: item.name,
                                    }));                         

                                    setValue("companyName", item.name);
                                  }}
                                />
                              )}
                            />
                          </div>
                          {errors.companyName ? (
                            <span className="error">{errors.companyName}</span>
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={() => {
                        reset({
                          companyId: "",
                          mobileNum: "",
                          status: [],
                          fromDate: "",
                          toDate: "",
                          campaignId: "",
                          companyName: "",
                        });
                        handleReset();
                      }}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RcsDashboardFilterModal;
